import styled, { css } from 'styled-components';
import {
  StyledButton,
  StyledButtonContainer,
  StyledReactTooltip,
} from '../../globalStyled';
import { fontUi, pill } from '../../theme/typography';

export const StyledTeamSquadContainer = styled.section`
  width: 100%;
`;

export const StyledChartContainer = styled.div`
  padding: 15px 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  }
`;

export const StyledCard = styled.div`
  padding: 0px;
  background: transparent;
  > p {
    margin: 14px 0;
    ${fontUi};
    font-style: normal;
    font-weight: 500;
    font-size: 14.222px;
    line-height: 16px;
    letter-spacing: 0.005em;
    color: ${({ theme }) => theme.text};
  }
`;

export const StyledCardDetailItem = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  padding: 16px 10px;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 33%;
  ${({ half }) => {
    if (half)
      return css`
        width: 50%;
      `;
  }}
  ${({ oneThird }) => {
    if (oneThird)
      return css`
        flex: 1 1 0;
        width: auto;
        min-width: 0;
      `;
  }}
  ${({ topBorder }) => {
    if (topBorder)
      return css`
        border-top: 1px solid ${({ theme }) => theme.borderSubtle};
      `;
  }}
  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.borderSubtle};
  }
`;

export const StyledStayCluster = styled.div`
  display: flex;
  flex-direction: row;
  flex: 2 1 0;
  width: auto;
  min-width: 0;
  border-right: 1px solid ${({ theme }) => theme.borderSubtle};

  & > * {
    flex: 1 1 0;
    width: auto;
    min-width: 0;
  }
`;

export const StyledValue = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: ${({ color, theme }) => color || theme.text};
`;
export const StyledLabel = styled.span`
  ${fontUi};
  font-size: 11px;
  font-weight: 500;
  color: ${({ theme }) => theme.textFaint};
  text-align: center;
  letter-spacing: 0.77px;
  padding-top: 5px;
`;

export const StyledPlayerData = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledPlayerControlButton = styled(StyledButton)`
  min-width: 138px;
  padding: 12px 10px;
  font-size: 14px;
  margin: 0 5px;
  @media only screen and (max-width: 426px) {
    width: 49%;
  }
`;

export const StyledControlContainer = styled(StyledButtonContainer)`
  justify-content: space-between;
  @media only screen and (max-width: 426px) {
    bottom: 0;
  }
`;

export const StyledTeamName = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.textMuted};
  font-weight: 500;
  ${fontUi};
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-bottom: 20px;
`;

export const StyledInjuredLabel = styled.div`
  height: 35px;
  padding: 11px 14px 10px 15px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  ${({ type }) => {
    if (type === 'academy') {
      return css`
        background-color: #00996b;
      `;
    }
    if (type === 'injured' || type === 'suspended') {
      return css`
        background-color: #de3e32;
      `;
    }
    if (type === 'loanedOut') {
      return css`
        background-color: #7f7f7f;
      `;
    }
    if (type === 'loanedIn' || type === 'booked') {
      return css`
        background-color: #fdca40;
        span {
          color: #000;
        }
      `;
    }
  }}
`;

export const StyledLeftLabel = styled.span`
  color: #fff;
  ${fontUi};
  font-size: 14px;
  font-weight: 500;
  padding-left: 15px;
`;

export const StyldRightLabel = styled.span`
  ${fontUi};
  font-size: 14px;
  color: #fff;
`;

export const StyledPlus = styled.span`
  ${fontUi};
  font-weight: bold;
  font-size: 26px;
  position: absolute;
  left: 5px;
  top: 2px;
`;

export const StyledHeader = styled.div`
  padding-top: 20px;
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.text};
  padding-bottom: 20px;
  > h3 {
    text-align: center;
    margin-bottom: 0px;
    ${fontUi};
    font-size: 20px;
    font-weight: 800;
    letter-spacing: 0.2px;
    line-height: 34px;
    color: ${({ theme }) => theme.text};
  }
`;

export const StyledButtonColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 15px;
`;
export const StyledFullWidthButton = styled(StyledButton)`
  width: 100%;
  margin-top: 0;
  box-shadow: none;
  ${({ secondary, theme }) => {
    if (secondary) {
      return css`
        border: 1px solid ${theme.border};
        background-color: ${theme.hover};
        color: ${theme.textMuted};
      `;
    }
  }}
`;

export const StyledInsight = styled.span`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  line-height: 1;

    svg {
    display: block;
    width: 12px;
    height: 12px;
    flex-shrink: 0;
    margin: 0;
  }
`;

export const StyledToggleTeamView = styled.div`
  margin: 0 15px 20px;
  display: flex;
  position: relative;
  flex-direction: row;
  gap: 4px;
  padding: 3px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.hover};

  button {
    ${pill};
    ${fontUi};
    font-size: 12px;
    font-weight: 600;
    flex: 1;
    line-height: 1;
    text-box: unset;
    text-box-trim: none;
    color: ${({ theme }) => theme.textFaint};
    border: 0;
    outline: 0;
    padding: 8px 10px;
    cursor: pointer;
    background: transparent;
    gap: 4px;

    &.active {
      color: ${({ theme }) => theme.text};
      background: ${({ theme }) => theme.card};
    }
    svg {
      display: block;
      width: 12px;
      height: 12px;
      margin: 0;
      flex-shrink: 0;
    }
  }
`;

export const StyledDarkReactTooltip = styled(StyledReactTooltip)`
  box-shadow: 0 0 15px 5px rgba(17, 17, 17, 0.08);
  font-family: Archivo;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.card};
  width: 190px;
  font-weight: 500;
  &.__react_component_tooltip.show {
    color: ${({ theme }) => theme.text};
    font-size: 13px;
    line-height: 18px;
    border-radius: 6px;
    opacity: 1;
  }
`;

export const StyledPatronLabel = styled.span`
  cursor: pointer;
`;
